import React from "react";
import styled, { keyframes } from "styled-components";

const ModernSpinner = () => {
  return (
    <Wrapper>
      <GlassCard>
        <Ring />
        <InnerCircle />
        <Text>Preparing your webinar...</Text>
      </GlassCard>
    </Wrapper>
  );
};

export default ModernSpinner;

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0% { transform: scale(0.9); opacity: 0.6; }
  50% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.9); opacity: 0.6; }
`;

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a, #1e293b);
`;

const GlassCard = styled.div`
  position: relative;
  width: 220px;
  height: 220px;
  border-radius: 20px;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
`;

const Ring = styled.div`
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(#38bdf8, #00838c, #00838c, #00838c);
  animation: ${rotate} 1.5s linear infinite;
  filter: blur(1px);
`;

const InnerCircle = styled.div`
  width: 90px;
  height: 90px;
  background: #0f172a;
  border-radius: 50%;
  z-index: 2;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Text = styled.div`
  position: absolute;
  bottom: 20px;
  font-size: 14px;
  color: #e2e8f0;
  letter-spacing: 0.5px;
  text-align: center;
`;
